var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"appoint_imm",on:{"click":function($event){return _vm.showWxCrad()}}}),_c('show-assisant',{ref:"assisant"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }